import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'
import Model from './ModelBdlogic.mjs'

export const FormItemRuleTitle = props => (
    <FormItemBizProp
        Model={Model}
        prop="ruleTitle"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseBdlogic(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemRuleTitle />
        </FormChooseDesign>
    )
}
